import { useState, useEffect } from 'react';
import HeroSection from './components/HeroSection';
import DeclarationSection from './components/DeclarationSection';
import InfographicSection from './components/InfographicSection';
import StatisticsSection from './components/StatisticsSection';
import CommentsSection from './components/CommentsSection';
import TimelineSection from './components/TimelineSection';
import ResourcesSection from './components/ResourcesSection';
import DonationSection from './components/DonationSection';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { supabase } from '../../lib/supabase';
import HowToUseSection from './components/HowToUseSection';

const queryClient = new QueryClient();

export default function Home() {
  const [signatureCount, setSignatureCount] = useState(0);
  const [petitionCount, setPetitionCount] = useState(0);
  const [expirDt, setExpirDt] = useState<string>('');

  useEffect(() => {
    const fetchSignatureCount = async () => {
      try {
        const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
        const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;
        if (!supabaseUrl || !supabaseAnonKey) return;

        const { count, error } = await supabase
          .from('signers')
          .select('*', { count: 'exact', head: true });

        if (error) {
          console.error('Supabase error while fetching signature count:', error);
          return;
        }

        if (count !== null) {
          setSignatureCount(count);
        }
      } catch (err) {
        console.error('Unexpected error fetching signature count:', err);
      }
    };

    const fetchPetitionCount = async () => {
      try {
        const petitId = import.meta.env.VITE_PETIT_ID;
        const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
        const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

        if (!supabaseUrl || !supabaseAnonKey || !petitId) return;

        const res = await fetch(
          `${supabaseUrl}/functions/v1/petition-crawler?petitId=${petitId}`,
          {
            headers: {
              Authorization: `Bearer ${supabaseAnonKey}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (!res.ok) {
          console.error('petition-crawler fetch failed:', res.status);
          return;
        }

        const data = await res.json();
        if (data.success && data.agreCo !== null && data.agreCo !== undefined) {
          setPetitionCount(Number(data.agreCo));
        }
        if (data.expirDt) {
          setExpirDt(data.expirDt);
        }
      } catch (err) {
        console.error('Unexpected error fetching petition count:', err);
      }
    };

    fetchSignatureCount();
    fetchPetitionCount();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <div className="min-h-screen bg-white">
        <Navbar />
        <HeroSection 
          signatureCount={signatureCount} 
          petitionCount={petitionCount}
          expirDt={expirDt}
        />
        <DeclarationSection />
        <StatisticsSection signatureCount={signatureCount} />
        <CommentsSection />
        <HowToUseSection />
        <InfographicSection />
        <TimelineSection />
        <ResourcesSection />
        <DonationSection />
        <Footer />
      </div>
    </QueryClientProvider>
  );
}